// extracted by mini-css-extract-plugin
export default {"section6":"style_section6__XYOZJ","text_input":"style_text_input__m0mfG"};